<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <header-bar></header-bar>

    <div id="download-dialog" ref="downloadDialog">
      <div class="download-dialog-wrap">
        <div class="download-dialog-header">
          <p id="download-dialog-md-title">
            <span class="icon iconfont viewAddtodownload-copy"></span> Download Software
          </p>
          <!-- <p id="download-dialog-xs-title">3D FastView</p> -->
          <span class="icon iconfont viewziyuanldpi" @click="closeDialog"></span>
        </div>
        <div class="download-dialog-body">
          <p class="download-dialog-label">Version</p>
          <div class="download-dialog-list">
            <div class="download-dialog-list-item">
              <p @click="selectHandle('standard,32',$event)">
                Standard 32bit
                <img src="../static/images/download-select@2x.png" alt />
              </p>
              <p @click="selectHandle('standard,64',$event)">
                Standard 64bit
                <img src="../static/images/download-unselect@2x.png" alt />
              </p>
            </div>
            <div class="download-dialog-list-item">
              <p @click="selectHandle('professional,32',$event)">
                Professional 32bit
                <img src="../static/images/download-unselect@2x.png" alt />
              </p>
              <p @click="selectHandle('professional,64',$event)">
                Professional 64bit
                <img src="../static/images/download-unselect@2x.png" alt />
              </p>
            </div>
          </div>
          <p class="download-dialog-label">Language</p>
          <el-select class="download-language" v-model="lang" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </div>
        <button @click="onSubmit">Confirm</button>
      </div>
    </div>
    <div id="download-dialog" ref="downloadDialogFast">
      <div class="download-dialog-wrap">
        <div class="download-dialog-header">
          <p id="download-dialog-md-title">
            <span class="icon iconfont viewAddtodownload-copy"></span> Download Software
          </p>
          <!-- <p id="download-dialog-xs-title">3D FastView</p> -->
          <span class="icon iconfont viewziyuanldpi" @click="closeDialogFast"></span>
        </div>
        <div class="download-dialog-body">
          <p class="download-dialog-label">Version</p>
          <div class="download-dialog-list">
            <div class="download-dialog-list-item">
              <p @click="selectHandle('fast,32',$event)">
                32bit
                <img src="../static/images/download-select@2x.png" alt />
              </p>
            </div>
            <div class="download-dialog-list-item">
              <p @click="selectHandle('fast,64',$event)">
                64bit
                <img src="../static/images/download-unselect@2x.png" alt />
              </p>
            </div>
          </div>
          <p class="download-dialog-label">Language</p>
          <el-select class="download-language" v-model="langFast" placeholder="请选择">
            <el-option
              v-for="item in fastOptions"
              :key="item.value"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </div>
        <button @click="onSubmit">Confirm</button>
      </div>
    </div>
    <div id="download-email-dialog" ref="downloadEmailDialog">
      <div class="download-dialog-wrap">
        <div class="download-dialog-header">
          <p id="download-dialog-xs-title">3D FastView</p>
          <span class="icon iconfont viewziyuanldpi" @click="closeEmailDialog"></span>
        </div>
        <div id="download-dialog-body-xs">
          <div>
            <p>You could visit the link to get the software package</p>
            <p>https://3dview.cadwonder.net</p>
            <p>Please input your email, we will send you the installation package through Email in 24 hours.</p>
            <input type="text" v-model="email" placeholder="Your Email" />
          </div>
          <button @click="onSubmitXs">Confirm</button>
        </div>
      </div>
    </div>

    <el-dialog
      custom-class="buy-finish-dialog-index"
      :visible.sync="dialogEmailFinishVisible"
      :modal="true"
      width="40%"
    >
      <div class="buy-finish-box">
        <span class="icon iconfont viewxiaolian"></span>
        <p>Thank you for contacting us.</p>
        <p>We have received your enquiry and will respond to you soon.</p>
      </div>
    </el-dialog>
    <router-view />
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import HeaderBar from "../src/components/HeaderBar";
import FooterBar from "../src/components/FooterBar";
import {
  addTrial,
  downInstallPackage,
  searchLanguage
} from "../src/utils/http/loadData";
import animate from "animate.css";
export default {
  name: "App",
  components: {
    HeaderBar,
    FooterBar
  },
  data() {
    return {
      dialogEmailFinishVisible: false,
      lang: "en",
      langFast: "en",
      productId: 2,
      selectProduct: 1,
      versionId: 1,
      softbit: "32",
      email: "",
      options: [],
      fastOptions: []
    };
  },
  methods: {
    selectHandle(type, event) {
      // console.log(event.target.tagName)
      var li = type.split(",");
      this.softbit = li[1];
      switch (li[0]) {
        case "standard":
          this.versionId = "2";
          break;
        case "professional":
          this.versionId = "3";
          break;
        case "fast":
          this.versionId = "1";
          this.lang = this.langFast;
          this.productId = 1;
          break;
        default:
          this.versionId = "2";
          break;
      }
      var domList = document.querySelectorAll(".download-dialog-list-item");
      for (var i = 0; i < domList.length; i++) {
        // console.log(domList[i].children[0])
        for (var j = 0; j < domList[i].children.length; j++) {
          // console.log(domList[i].children[j])
          domList[i].children[j].children[0].src =
            "../static/images/download-unselect@2x.png";
        }
      }
      if (event.target.tagName === "P") {
        event.target.children[0].src =
          "../static/images/download-select@2x.png";
        // if(event.target.children[0].src==='../static/images/download-unselect@2x.png'){
        //   event.target.children[0].src='../static/images/download-select@2x.png'
        // }else{
        //   event.target.children[0].src='../static/images/download-unselect@2x.png'
        // }
        // console.log(event.target.children[0].src='../static/images/download-select@2x.png')
      } else if (event.target.tagName === "IMG") {
        // console.log('img')
        event.target.src = "../static/images/download-select@2x.png";
      } else {
        return;
      }
    },

    initGtag() {
      window.dataLayer = window.dataLayer || [];
    },
    gtag() {
      console.log(window.dataLayer);
      window.dataLayer.push(arguments);
    },
    gtag_report_conversion(url) {
      this.gtag("js", new Date());

      this.gtag("config", "AW-831366347");
      var callback = function() {
        if (typeof url === "undefined") {
          window.location = url;
        }
      };
      //download  AW-831366347/l8x_CJeft5oBEMvJtowD
      this.gtag("event", "conversion", {
        send_to: "AW-831366347/l8x_CJeft5oBEMvJtowD",
        event_callback: callback
      });
      return false;
    },
    onSubmit() {
      // console.log(
      //   "versionid=" +
      //     this.versionId +
      //     ",lang=" +
      //     this.lang +
      //     ",bit=" +
      //     this.softbit +
      //     ",product=" +
      //     this.productId
      // );
      this.gtag_report_conversion(window.location.href);
      downInstallPackage(
        this.versionId,
        this.langFast,
        this.softbit,
        this.productId
      ).then(res => {
        console.log(res.data.bizData);
        if (res.data.rtnCode === "0000000") {
          this.closeDialog();
          this.closeDialogFast();
          this.closeEmailDialog();
          if (res.data.bizData.downloadLink) {
            // this.dialogEmailFinishVisible = true;
            // let aDom = document.createElement("a");
            // aDom.setAttribute("href", res.data.bizData.downloadLink);
            // aDom.setAttribute("download", "dwg.exe");
            // document.body.appendChild(aDom);
            // aDom.click();
            // document.body.removeChild(aDom);
            window.location.href = res.data.bizData.downloadLink;
          } else {
            alert("Not Found Software Package！");
          }
        } else {
          alert(res.data.msg);
        }
      });
    },
    onSubmitXs() {
      addTrial(this.email, this.productId).then(res => {
        console.log(res);
        if (res.data.rtnCode === "0000000") {
          this.dialogEmailFinishVisible = true;
        } else {
          alert(res.data.msg);
        }
      });
      this.closeEmailDialog();
    },
    closeDialog() {
      this.$refs.downloadDialog.style.visibility = "hidden";
    },
    closeDialogFast() {
      this.$refs.downloadDialogFast.style.visibility = "hidden";
    },
    closeEmailDialog() {
      this.$refs.downloadEmailDialog.style.visibility = "hidden";
    },
    showDialog() {
      this.versionId = 2;
      if (document.body.clientWidth <= 768) {
        this.$refs.downloadEmailDialog.style.visibility = "visible";
      } else {
        searchLanguage(0, 10, 2).then(res => {
          if (res.data.rtnCode === "0000000") {
            this.options = res.data.bizData.list;
          }
        });
        this.$refs.downloadDialog.style.visibility = "visible";
      }
    },
    showDialogFast() {
      this.versionId = 1;
      if (document.body.clientWidth <= 768) {
        this.$refs.downloadEmailDialog.style.visibility = "visible";
      } else {
        searchLanguage(0, 10, 1).then(res => {
          if (res.data.rtnCode === "0000000") {
            this.fastOptions = res.data.bizData.list;
          }
        });
        this.$refs.downloadDialogFast.style.visibility = "visible";
      }
    }
  },
  mounted() {
    this.$jsonp(
      "https://www.googletagmanager.com/gtag/js?id=AW-831366347"
    ).then(this.gtag);

    this.initGtag();
  }
};
</script>

<style lang="scss">
@import "../static/css/app.scss";
html {
  font-size: 100px !important;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue